import { createSlice } from '@reduxjs/toolkit';
import { themeNames } from '../theme/base';

const initialState = {
  mode: themeNames.SECURITY.id,
  color: '',
};

export const globalOptions = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setGlobalTheme: (state, action) => {
      state.mode = action.payload;
    },
    setGlobalColorScheme: (state, action) => {
      state.color = action.payload;
    },
  },
});

export const { actions, reducer } = globalOptions;
